import { ComponentProps, FC, PropsWithChildren } from 'react';
import styled from 'styled-components';

import FlowCanvas from 'dashboard/components-lib/FlowPlotter/FlowCanvas';
import PanZoomBox from 'dashboard/components-lib/PanZoomBox';

const FillParent = styled.div`
  touch-action: none;
  position: relative;
  height: 100%;
  width: 100%;
`;

interface FlowPlotterProps {
  edgeComponents: ComponentProps<typeof FlowCanvas>['edgeComponents'];
  edges: ComponentProps<typeof FlowCanvas>['edges'];
  nodeComponents: ComponentProps<typeof FlowCanvas>['nodeComponents'];
  nodes: ComponentProps<typeof FlowCanvas>['nodes'];
  onDragAndDrop?: ComponentProps<typeof FlowCanvas>['onDragAndDrop'];
  onNodeCustomEvent?: ComponentProps<typeof FlowCanvas>['onNodeCustomEvent'];
  onSurroundNodes?: ComponentProps<typeof FlowCanvas>['onSurroundNodes'];
}

const FlowPlotter: FC<PropsWithChildren<FlowPlotterProps>> = ({
  children,
  edgeComponents,
  edges,
  nodeComponents,
  nodes,
  onDragAndDrop,
  onNodeCustomEvent,
  onSurroundNodes,
}) => {
  return (
    <FillParent>
      <PanZoomBox preventPageScrollOnPan showZoomControls>
        <FlowCanvas
          edgeComponents={edgeComponents}
          edges={edges}
          nodeComponents={nodeComponents}
          nodes={nodes}
          onDragAndDrop={onDragAndDrop}
          onNodeCustomEvent={onNodeCustomEvent}
          onSurroundNodes={onSurroundNodes}
        />
      </PanZoomBox>
      {children}
    </FillParent>
  );
};

export default FlowPlotter;
